import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <main id="main-content" className="flex min-h-screen flex-col items-center justify-center px-4">
      <h1 className="text-4xl font-bold text-content">
        404
      </h1>
      <p className="mt-2 text-lg text-content-secondary">
        Page not found
      </p>
      <p className="mt-1 text-sm text-content-tertiary">
        The page you are looking for does not exist or has been moved.
      </p>
      <Link
        to="/"
        className="mt-6 rounded-md bg-primary px-4 py-2 text-sm font-medium text-content-on-primary hover:bg-primary-hover focus:outline-none focus:ring-2 focus:ring-brand-600 focus:ring-offset-2"
      >
        Back to Dashboard
      </Link>
    </main>
  );
}
